import { Link } from 'react-router-dom';

export default function ServicesOverview() {
  return (
    <section id="services" className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8" style={{ backgroundColor: '#F8F6F3' }}>
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-8 sm:mb-12 md:mb-16">
          <p className="text-xs sm:text-sm font-semibold text-amber-700 tracking-widest uppercase mb-3 sm:mb-4">
            WHAT WE OFFER
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-3 sm:mb-4">
            Comprehensive
            <br />
            <span className="italic font-serif text-emerald-700">Export Solutions</span>
            <br />
            for Your Business
          </h2>
          <p className="text-gray-600 text-sm sm:text-base mt-3 sm:mt-4">
            End-to-end services ensuring seamless international trade
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {/* Card 1 - Export Documentation */}
          <Link to="/services#export-documentation" className="relative rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 h-64 sm:h-72 md:h-80 group cursor-pointer transition-all hover:scale-105" style={{ backgroundColor: '#14B8A6' }}>
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white/20 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-file-list-3-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">Export Documentation</h3>
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              Complete paperwork and certification support for hassle-free customs compliance
            </p>
            <i className="ri-arrow-right-line text-xl sm:text-2xl text-white absolute bottom-6 sm:bottom-10 right-6 sm:right-10 opacity-0 group-hover:opacity-100 transition-all"></i>
          </Link>

          {/* Card 2 - Quality Assurance */}
          <Link to="/services#quality-assurance" className="relative rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 h-64 sm:h-72 md:h-80 group cursor-pointer transition-all hover:scale-105" style={{ backgroundColor: '#E67E50' }}>
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white/20 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-shield-check-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">Quality Assurance</h3>
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              Rigorous quality checks at every stage to ensure premium products meet international standards
            </p>
            <i className="ri-arrow-right-line text-xl sm:text-2xl text-white absolute bottom-6 sm:bottom-10 right-6 sm:right-10 opacity-0 group-hover:opacity-100 transition-all"></i>
          </Link>

          {/* Card 3 - Logistics Support */}
          <Link to="/services#logistics-support" className="relative rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 h-64 sm:h-72 md:h-80 group cursor-pointer transition-all hover:scale-105" style={{ backgroundColor: '#B8A8D4' }}>
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white/20 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-global-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">Logistics Support</h3>
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              Reliable shipping solutions to deliver your products safely across the globe
            </p>
            <i className="ri-arrow-right-line text-xl sm:text-2xl text-white absolute bottom-6 sm:bottom-10 right-6 sm:right-10 opacity-0 group-hover:opacity-100 transition-all"></i>
          </Link>

          {/* Card 4 - Customs Clearance */}
          <Link to="/services#customs-clearance" className="relative rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 h-64 sm:h-72 md:h-80 group cursor-pointer transition-all hover:scale-105" style={{ backgroundColor: '#059669' }}>
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white/20 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-government-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">Customs Clearance</h3>
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              Expert customs brokerage ensuring smooth clearance and regulatory compliance
            </p>
            <i className="ri-arrow-right-line text-xl sm:text-2xl text-white absolute bottom-6 sm:bottom-10 right-6 sm:right-10 opacity-0 group-hover:opacity-100 transition-all"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
